import { MutationTree } from "vuex";
import { CustomerState } from "@/store/customer/type";
import { Customer } from "@/models/customer";
import { ShoppingCart } from "@/models/shopping";
import Uicookie from "@/utils/cookie";
import Vue from "vue";

export enum CustomerMutations {
  SET_CUSTOMER_TOKEN = "SET_CUSTOMER_TOKEN",
  GET_CUSTOMER_TOKEN = "GET_CUSTOMER_TOKEN",
  SET_CUSTOMER_CART = "SET_CUSTOMER_CART",
  SET_CUSTOMER = "SET_CUSTOMER",
  LOGOUT_CUSTOMER = "LOGOUT_CUSTOMER",
  ADD_CUSTOMER_ADDRESS = "ADD_CUSTOMER_ADDRESS",
  REMOVE_CUSTOMER_ADDRESS = "REMOVE_CUSTOMER_ADDRESS"
}

export const mutations: MutationTree<CustomerState> = {
  [CustomerMutations.SET_CUSTOMER_TOKEN](state, customer: Customer): void {
    if (!customer) {
      state.isAuthenticated = false;
      state.me = null;
      state.cart = null;
    } else {
      state.isAuthenticated = true;
      state.me = customer;
      if (customer.shoppingCart) {
        state.cart = customer.shoppingCart;
      } else {
        state.cart = null;
        Uicookie.deleteCart();
      }
    }
  },
  [CustomerMutations.LOGOUT_CUSTOMER](state): void {
    state.isAuthenticated = false;
    state.me = null;
    state.cart = null;
  },

  [CustomerMutations.SET_CUSTOMER](state, customer: Customer): void {
    if (!customer) {
      state.isAuthenticated = false;
      state.me = null;
      state.cart = null;
    } else {
      state.isAuthenticated = true;
      state.me = customer;
      if (customer.shoppingCart) {
        state.cart = customer.shoppingCart;
      } else {
        state.cart = null;
        Uicookie.deleteCart();
      }
    }

  },

  [CustomerMutations.REMOVE_CUSTOMER_ADDRESS](state, addressName): void {
    const currentUser = Customer.of({ ...state.me });

    if (currentUser && currentUser.addresses) {

      currentUser.addresses.forEach((addressWithName, i, addresses) => {
        if (addressWithName.name === addressName) {
          addresses.splice(i, 1);
        }
      });
      if (currentUser.defaultShippingAddress === addressName) {
        currentUser.defaultShippingAddress = null;
      }
      if (currentUser.defaultBillingAddress === addressName) {
        currentUser.defaultBillingAddress = null;
      }
      state.me = currentUser;
    }
  },

  [CustomerMutations.ADD_CUSTOMER_ADDRESS](state, { isNew, address }): void {

    const currentUser = Customer.of({ ...state.me });
    const addressValue = address;
    if (currentUser) {
      if (isNew) {
        const addressToAdd = addressValue;

        if (currentUser.addresses && currentUser.addresses.length > 0) {
          currentUser.addresses.push(addressToAdd);
        } else {
          currentUser.addresses = [addressToAdd];
        }
      } else {
        if (currentUser.addresses && currentUser.addresses.length > 0) {
          currentUser.addresses.forEach((addressWithName, i, addresses) => {
            if (addressWithName.name === addressValue.name) {
              addresses[i] = addressValue;
            }
          });
        }
      }

      if (address.defaultShipping) {
        if (currentUser.defaultShippingAddress !== addressValue.name) {
          currentUser.defaultShippingAddress = addressValue.name;
        }
      } else if (currentUser.defaultShippingAddress === addressValue.name) {
        currentUser.defaultShippingAddress = null;
      }
      if (address.defaultBilling) {
        if (currentUser.defaultBillingAddress !== addressValue.name) {
          currentUser.defaultBillingAddress = addressValue.name;
        }
      } else if (currentUser.defaultBillingAddress === addressValue.name) {
        currentUser.defaultBillingAddress = null;
      }
      currentUser.addresses ? currentUser.addresses.sort((a, b) => {
        if (a.name && b.name) {
          return a.name < b.name ? 1 : -1;
        }
        return 0;
      }) : [];

      state.me = currentUser;
    }
  },

  [CustomerMutations.SET_CUSTOMER_CART](state, cart: ShoppingCart): void {
    if (!cart) {
      Vue.$cookies.remove("qorus_cart");
    }
    state.cart = cart;
    if (state.me) {
      state.me.shoppingCart = cart;
    }
  },

};